import * as React from "react";

const Diff: React.FunctionComponent = () => {
    return (
        <p>Diff (WIP)</p>
    );
};

export default Diff;